export class ResponseResult<T> {
  total: number;
  data: T | [];
}
